export default "__VITE_ASSET__phmuNYGn__"